var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataAnalyticsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 925,
    width: 135,
    height: 136
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-347 -925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 19.6875 19.6875 19.6875 19.6875 115.312 115.312 115.312 115.312 106.875 28.125 106.875Z",
    transform: "matrix(1 0 0 1.00741 347 925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 49.2188 52.0312 49.2188 52.0312 98.4375 36.5625 98.4375Z",
    transform: "matrix(1 0 0 1.00741 347 925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6562 19.6875 73.125 19.6875 73.125 98.4375 57.6562 98.4375Z",
    transform: "matrix(1 0 0 1.00741 347 925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75 49.2188 94.2188 49.2188 94.2188 98.4375 78.75 98.4375Z",
    transform: "matrix(1 0 0 1.00741 347 925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8438 73.125 115.312 73.125 115.312 98.4375 99.8438 98.4375Z",
    transform: "matrix(1 0 0 1.00741 347 925)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalyticsIcon);
export default __webpack_public_path__ + "static/media/dataAnalyticsIcon.a5714eb432dee8840c491a3fb873df60.svg";
export { ForwardRef as ReactComponent };